import { render, staticRenderFns } from "./PersonListItem.vue?vue&type=template&id=483ccfe6&scoped=true&"
import script from "./PersonListItem.vue?vue&type=script&lang=js&"
export * from "./PersonListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483ccfe6",
  null
  
)

export default component.exports